import React from 'react';
import Button, { CustomButtonProps } from './Button';

export default function OutlinedSecondaryButton({
  ...props
}: CustomButtonProps) {
  return <Button variant="outlined" color="secondary" {...props} />;
}
